const headers = {
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache',
  'Pragma': 'no-cache',
};

const SERVER = '/api'
export class EmblemApi {

  static async getNewDesignRequest() {
    try {
      const resp = await fetch(`${SERVER}/v3/design-requests/new-design-request`, {
        method: 'GET',
        headers: headers
      })
  
      if (!resp.ok) {
        throw new Error(`API request failed with status ${resp.status}`);
      }
  
      const data = await resp.json();
  
      if (!data.response?.designRequest) {
        throw new Error("Invalid or missing designRequest in API response");
      }
  
      return data.response.designRequest;
    } catch (error: any) {
      throw new Error(`Failed to fetch new design request: ${error?.message}`);
    }
  }

  static async getSteps(designRequest?: unknown) {
    try {
      const reqData = JSON.stringify(designRequest)
      const resp = await fetch(`${SERVER}/v3/design-requests/steps`, {
        method: 'POST',
        headers: headers,
        body: reqData
      });
  
      if (!resp.ok) {
        throw new Error(`API request failed with status ${resp.status}`);
      }
  
      const data = await resp.json()
  
      if (!data.response?.steps || !Array.isArray(data.response.steps)) {
        throw new Error("Invalid or missing steps in API response");
      }
  
      return data.response.steps;
    } catch (error: any) {
      throw new Error(`Failed to fetch steps: ${error?.message}`);
    }
  }

  static async uploadImage(file: File, id: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', id);

    try {
      const resp = await fetch(`${SERVER}/v3/design-requests/uploadimage/`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      });

      if (!resp.ok) {
        const errorData = await resp.json();
        throw new Error(errorData.errorDetail?.messages?.[0] || `Failed to upload image: ${resp.status} ${resp.statusText}`);
      }

      const data = await resp.json();

      if (!data.response?.image) {
        throw new Error('No image data returned from server.');
      }

      return data.response.image;
    } catch (error: any) {
      console.error('Error uploading image to WE:', error);
      throw error;
    }
  }
}
